// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.snackbar > div {\n  max-height: 100%;\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
